import React from 'react'
import classNames from 'classnames'
import { useHistory } from 'react-router-dom'

import styles from './Subnav.module.css'
import { spacerClassName } from '../Page'
import { IconButton } from '../Icon'

export default function Subnav({ title, nav, actions, withBackButton }) {
  const history = useHistory()

  return (
    <>
      <div className={styles.spacer} />
      <div className={classNames(styles.subnav, spacerClassName)}>
        <div className={styles.child}>
          {withBackButton && (
            <div className={styles.backButton}>
              <IconButton
                large
                onClick={history.goBack}
                icon="back"
                color="black"
              />
            </div>
          )}
          <h1 className={styles.title}>{title}</h1>
        </div>
        {nav && (
          <div className={classNames(styles.child, styles.nav)}>{nav}</div>
        )}
        <div className={classNames(styles.child, styles.actions)}>
          {actions}
        </div>
      </div>
    </>
  )
}
